module.exports = __webpack_public_path__ + "static/DonaAlt-Medium-6cb9b3d5384996206f9695eee398ab7c.woff";